import { datadogRum } from "@datadog/browser-rum";

type RumActionContextValue = string | number | boolean;
type RumActionContext = Record<string, RumActionContextValue | undefined>;

type CoursePageViewContext = {
  courseId: string;
  integrationId?: string;
  moduleId?: string;
  resourceId?: string;
  routeName: string;
};

type LearningRumActivitySource = "course" | "learning_activities";
type LearningRumActivityType = "AITUTOR";

type LearningActivityViewedContext = {
  activityId: string;
  activitySource: LearningRumActivitySource;
  activityType: LearningRumActivityType;
  courseId?: string;
  integrationId?: string;
  moduleId?: string;
};

type CourseEnrollmentCompletedContext = {
  courseId?: string;
  courseName?: string;
};

const addRumAction = (name: string, context: RumActionContext) => {
  const definedContext: Record<string, RumActionContextValue> = {
    event_source: "frontend_rum",
  };

  Object.entries(context).forEach(([key, value]) => {
    if (value !== undefined) {
      definedContext[key] = value;
    }
  });

  datadogRum.addAction(name, definedContext);
};

export const trackCoursePageView = ({
  courseId,
  integrationId,
  moduleId,
  resourceId,
  routeName,
}: CoursePageViewContext) => {
  addRumAction("course_page_view", {
    course_id: courseId,
    integration_id: integrationId,
    module_id: moduleId,
    resource_id: resourceId,
    route_name: routeName,
  });
};

export const trackLearningActivityViewed = ({
  activityId,
  activitySource,
  activityType,
  courseId,
  integrationId,
  moduleId,
}: LearningActivityViewedContext) => {
  addRumAction("learning_activity_viewed", {
    activity_id: activityId,
    activity_source: activitySource,
    activity_type: activityType,
    course_id: courseId,
    integration_id: integrationId,
    module_id: moduleId,
  });
};

export const trackCourseEnrollmentCompleted = ({ courseId, courseName }: CourseEnrollmentCompletedContext) => {
  addRumAction("course_enrollment_completed", {
    course_id: courseId,
    course_name: courseName,
  });
};
